import { useMutation, useQueryClient } from '@tanstack/react-query'
import skipSurvey from '../api/feedback/skipFeedbackSurvey'
import { GET_FEEDBACK_SURVEY_RESPONSE_KEY } from '../constants'

const useSkipFeedbackSurvey = () => {
  const queryClient = useQueryClient()
  const mutation = useMutation(
    ({
      surveyId,
      skipTimerDuration,
    }: {
      surveyId: string
      skipTimerDuration: number
    }) => skipSurvey(surveyId, skipTimerDuration),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_FEEDBACK_SURVEY_RESPONSE_KEY],
        })
      },
    },
  )
  return mutation
}

export default useSkipFeedbackSurvey
